export const UNIT_EMERGENCY_LABEL = 'Unit Emergency';
export const UNIT_DISPATCH_AREA_COLUMN_DEFINITION = 'UNIT_DISPATCH_AREA';
export const UNIT_BEAT_COLUMN_DEFINITION = 'UNIT_BEAT';
export const REGULAR_ASCENDING_SORT_DIRECTION = 'REGULAR_ASCENDING';
export const REGULAR_DESCENDING_SORT_DIRECTION = 'REGULAR_DESCENDING';
